/**
 * Web: nothing. A QuizButton's colours already ease there with a CSS
 * transition (`web:transition-[background-color,border-color,opacity]`).
 * Native's twin (`QuizButtonCrossfade.native.tsx`) cross-fades them instead,
 * because NativeWind cannot run transition classes on native.
 */
export function QuizButtonCrossfade(_props: { containerClass: string }) {
  return null;
}
